var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"trueconf"},[_c('iframe',{staticClass:"hidden",attrs:{"id":"conference","allowfullscreen":"allowfullscreen","allow":"microphone; camera; autoplay; display-capture","src":_vm.url}})])}
var staticRenderFns = []

export { render, staticRenderFns }